import React from "react";
import styles from "./Leaders.module.css";
import ias from "../../Asset/ias.webp";
import deepak from "../../Asset/deepak.webp";
import poonam from "../../Asset/poonam.webp";
import avinash from "../../Asset/avinash.webp";
import himmat from "../../Asset/himmat.webp";

const leaders = [
  
  {
    name: "Mr.Dhiraj Suryavanshi",
    title: "Hon. Mayor",
    img: "https://cdn-icons-png.flaticon.com/512/3135/3135715.png",
  },
  {
    name: "Mr.Gajanan Magdum",
    title: "Hon. Deputy Mayor",
    img: "https://cdn-icons-png.flaticon.com/512/3135/3135715.png",
  },
  {
    name: "Mr. Satyam Gandhi. (IAS)",
    title: "Commissioner of Municipal Corporation",
    img: "https://cdn-icons-png.flaticon.com/512/3135/3135715.png",
  },
  {
    name: "Mr. Rahul Rokade",
    title: "Additional Commissioner-1",
    img: "https://cdn-icons-png.flaticon.com/512/3135/3135715.png",
  },
  {
    name: "Mr. Nilesh Deshmukh",
    title: "Additional Commissioner-2",
    img: "https://cdn-icons-png.flaticon.com/512/3135/3135715.png",
  },
];

const Leaders = () => {
  return (
    <section className={styles.wrapper}>
      <h2 className={styles.heading}> </h2>
      <div className={styles.container}>
        {leaders.map((leader, index) => (
          <div className={styles.card} key={index}>
            <img src={leader.img} alt={leader.name} className={styles.image} />
            <h3 className={styles.name}>{leader.name}</h3>
            <p className={styles.title}>{leader.title}</p>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Leaders;
